export default "__VITE_ASSET__wyzv$EPV__"